import { useLocation } from 'react-router';
import qs from 'qs';
import decodeUrlQuery from '../../helpers/decodeUrlQuery';
export function useVariantFromUrl() {
    const location = useLocation();
    const urlQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (!(urlQuery === null || urlQuery === void 0 ? void 0 : urlQuery.att))
        return {};
    const selectedVariantNames = decodeUrlQuery({
        urlQuery,
        parametersToBeDecoded: ['att']
    }).att;
    const values = selectedVariantNames.split('|');
    return { values };
}
//# sourceMappingURL=useVariantFromUrl.js.map